import React, { useEffect, useState } from 'react';

interface CountdownCircleProps {
    change?: boolean;
}

const CountdownCircle: React.FC<CountdownCircleProps> = ({ change }) => {
    const seconds = 20;
    const [timeLeft, setTimeLeft] = useState<number>(seconds);

    useEffect(() => {
        setTimeLeft(seconds);
        const intervalId = setInterval(() => {
            setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
        }, 1000);

        // Cleanup interval
        return () => clearInterval(intervalId);
    }, [change]);

    const radius = 6;
    const circumference = 2 * Math.PI * radius;
    const strokeDashoffset = (timeLeft / seconds) * circumference;

    return (
        <div style={{ width: '16px', height: '16px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <svg width="16" height="16">
                <circle
                    cx="8"
                    cy="8"
                    r={radius}
                    fill="none"
                    stroke="#eaeaea"
                    strokeWidth="2"
                />
                <circle
                    cx="8"
                    cy="8"
                    r={radius}
                    fill="none"
                    stroke="#878A99"
                    strokeWidth="2"
                    strokeDasharray={circumference}
                    strokeDashoffset={strokeDashoffset}
                    style={{ transition: 'stroke-dashoffset 1s linear' }}
                    transform="rotate(-90 8 8)"
                />
            </svg>
        </div>
    );
};

export default React.memo(CountdownCircle);